// Analytics Helper Functions
// Common analytics tracking functions for use throughout the application

import { analytics } from '../services/analytics/analytics';
import analyticsService from '../services/analytics/analyticsService';

/**
 * Track when a user opens an app (canonical: app_opened)
 */
export function trackAppOpen(appName: string, _windowId?: string, _spaceId?: string) {
  analytics.track('app_opened', { app_name: appName });
}

/**
 * Track when a user logs in
 */
export function trackLogin(method: string, userId?: string) {
  analyticsService.trackLogin(method, userId);
}

/**
 * Trigger Google Ads conversion tracking for successful user signup
 */
export function triggerGoogleAdsConversion() {
  try {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'conversion', {
        'send_to': 'AW-10789905168/NPayCK2Wn6QbEJDGg5ko',
      });
    }
  } catch (error) {
    console.error('Error firing Google Ads conversion:', error);
  }
}

/**
 * Track when a user encounters an error
 */
export function trackError(errorMessage: string, errorType: string, componentName?: string) {
  analyticsService.trackError(errorMessage, errorType, {
    component_name: componentName,
  });
}

/**
 * Track page views
 */
export function trackPageView(pageTitle?: string, pagePath?: string) {
  analyticsService.trackPageView({
    page_title: pageTitle || document.title,
    page_path: pagePath || window.location.pathname,
  });
}

/**
 * Set user properties when user info is available
 */
export function setUserProperties(userId: string, properties: Record<string, any>) {
  analyticsService.setUserProperties({
    user_id: userId,
    properties: {
      ...properties,
      last_seen: new Date().toISOString(),
    },
  });
}
